module.exports = __webpack_public_path__ + "img/clouds@2x.65c548b7.png";